import { rangeToString } from 'shared-utils/src/rangeUtils';
import { ALL_PROPERTY_TYPE_VALUES } from 'shared-constants/src/filters';

export const filtersAndLocationsToQObject = (filters, locations) => {
  const qObject = {};

  if (filters.tr) qObject.tr = filters.tr;
  if (filters.propertyTypeGroup) qObject.propertyTypeGroup = filters.propertyTypeGroup;

  if (filters.propertyTypes && filters.propertyTypes.length) {
    const ptypes = filters.propertyTypes.filter(function(pt) { return pt && pt !== 'tutte'; });
    if (ptypes.length) {
      qObject.propertyTypes = ptypes.map(function(pt) {
        const match = ALL_PROPERTY_TYPE_VALUES.find(function(v) { return v.display === pt || v.value === pt; });
        return match ? match.slug.replace(/\+/g, '-') : pt;
      });
    }
  }

  if (locations && locations.length) {
    const hkeys = locations.map((l) => l.hkey).filter(Boolean);
    if (hkeys.length) {
      qObject.q = hkeys;
    }
  }

  const priceRange = rangeToString(filters.price);
  if (priceRange) qObject.price = priceRange;

  const mqPriceRange = rangeToString(filters.mqPrice);
  if (mqPriceRange) qObject.mqPrice = mqPriceRange;

  const paymentRange = rangeToString(filters.payment);
  if (paymentRange) qObject.payment = paymentRange;

  const mqRange = rangeToString(filters.mq);
  if (mqRange) qObject.mq = mqRange;

  const roomsRange = rangeToString(filters.rooms);
  if (roomsRange) qObject.rooms = roomsRange;

  const bathroomsRange = rangeToString(filters.bathrooms);
  if (bathroomsRange) qObject.bathrooms = bathroomsRange;

  const parkingRange = rangeToString(filters.parkingSpaces);
  if (parkingRange) qObject.parkingSpaces = parkingRange;

  const constructionYearRange = rangeToString(filters.constructionYear);
  if (constructionYearRange) qObject.constructionYear = constructionYearRange;

  if (filters.condition && filters.condition.length && filters.condition[0] !== 'all') {
    const conditionArray = Array.isArray(filters.condition) ? filters.condition : [filters.condition];
    qObject.condition = conditionArray.flatMap((c) => c === 'nuovo-ristrutturato' ? ['nuovo', 'ristrutturato'] : [c]);
  }
  if (filters.heating && filters.heating.length && filters.heating[0] !== 'all') qObject.heating = filters.heating;
  if (filters.garden && filters.garden.length && filters.garden[0] !== 'all') qObject.garden = filters.garden;
  if (filters.balconyTerrace && filters.balconyTerrace.length && filters.balconyTerrace[0] !== 'all') qObject.balconyTerrace = filters.balconyTerrace;
  if (filters.furniture && filters.furniture.length && filters.furniture[0] !== 'all') qObject.furniture = filters.furniture;
  if (filters.commercial_building_location && filters.commercial_building_location.length) {
    qObject.commercial_building_location = filters.commercial_building_location;
  }

  if (filters.publicationDt && filters.publicationDt !== 'all') qObject.publicationDt = filters.publicationDt;
  if (filters.publisher && filters.publisher.length && filters.publisher[0] !== 'all') qObject.publisher = filters.publisher;
  if (filters.rentType && filters.rentType !== 'all') qObject.rentType = filters.rentType;
  if (filters.availability != null && filters.availability !== 'all') qObject.availability = filters.availability;
  if (filters.energyClass != null && filters.energyClass !== 'all') qObject.energyClass = filters.energyClass;
  if (filters.level != null && filters.level !== 'all') {
    const levelStr = filters.level;
    if (levelStr === 'piano terra') qObject.level = 0;
    else if (levelStr === 'intermedio') qObject.level = 999;
    else if (levelStr === 'ultimo') qObject.level = 1000;
    else if (!isNaN(Number(levelStr))) qObject.level = Number(levelStr);
  }
  if (filters.lift_level && !isNaN(Number(filters.lift_level))) {
    qObject.liftIfAtLeast = Number(filters.lift_level);
  } else if (filters.lift !== true && filters.lift !== false && !isNaN(Number(filters.lift)) && filters.lift != null) {
    qObject.liftIfAtLeast = Number(filters.lift);
  } else if (filters.lift === true || filters.lift === false) {
    qObject.lift = filters.lift;
  }
  if (filters.includes_property_ownership != null && filters.includes_property_ownership !== 'all') {
    qObject.includesPropertyOwnership = filters.includes_property_ownership;
  }

  if (filters.hasPhoto) qObject.hasPhoto = true;
  if (filters.hasAC) qObject.hasAC = true;
  if (filters.hasSwimmingPool) qObject.hasSwimmingPool = true;
  if (filters.hasReception) qObject.hasReception = true;
  if (filters.hasVirtualTour) qObject.hasVirtualTour = true;
  if (filters.isLux) qObject.isLux = true;

  if (filters.isUnderConstruction === true || filters.isUnderConstruction === false) {
    qObject.isUnderConstruction = filters.isUnderConstruction;
  }
  if (filters.onlyPrivateNegotiation === true) {
    qObject.isPrivateNegotiation = true;
  } else if (filters.excludePrivateNegotiation === true) {
    qObject.isPrivateNegotiation = false;
  }
  if (filters.isAuction === true || filters.isAuction === false) {
    qObject.isAuction = filters.isAuction;
  }

  if (filters.licenseTypeGroups && filters.licenseTypeGroups.length) {
    qObject.licenseTypeGroups = filters.licenseTypeGroups;
  }

  if (filters.officeType && filters.officeType.length) {
    qObject.officeType = filters.officeType;
  }

  if (filters.nearby) qObject.nearby = filters.nearby;
  if (filters.geocircle) qObject.geocircle = filters.geocircle;
  if (filters.geobounds) qObject.geobounds = filters.geobounds;
  if (filters.geopolygon) {
    qObject.geopolygon = Array.isArray(filters.geopolygon) ? filters.geopolygon : [filters.geopolygon];
  }
  if (filters.poi) qObject.poi = filters.poi;
  if (filters.qExpansion && filters.qExpansion !== '0') qObject.qExpansion = filters.qExpansion;

  if (filters.pId) qObject.pId = filters.pId;

  return qObject;
};
